export const howWeWorksData = [
  {
    id: 1,
    title: "Explore",
    description: [
      "Initial consultation to uncover core challenges and goals",
      "Identify potential AI opportunities to generate business value",
      "Define shared objectives and clear project scope together",
    ],
  },
  {
    id: 2,
    title: "Strategize",
    description: [
      "Create a roadmap aligned with business priorities and vision",
      "Select impactful use cases with measurable success indicators",
      "Plan scalable AI solutions with clear ROI expectations",
    ],
  },
  {
    id: 3,
    title: "Co-Create",
    description: [
      "Collaborative development with expert AI and domain teams",
      "Design and validate proof-of-concepts with real data",
      "Iterate and refine models using continuous client feedback",
    ],
  },
  {
    id: 4,
    title: "Implement",
    description: [
      "Integrate AI solutions smoothly into daily operations",
      "Deploy, test, and validate systems across use cases",
      "Train teams to maximize solution effectiveness and adoption",
    ],
  },
  {
    id: 5,
    title: "Evolve",
    description: [
      "Track performance, improve models, and optimize processes",
      "Scale AI solutions to new areas of opportunity",
      "Ensure continued alignment with business needs and strategy",
    ],
  },
];
